<template>
  <div>
    <div class="d-flex height-set-for-component" ref="fadeWhenModelOpen" style="position:relative;">
      <table
        class="tabletable-with-border table-responsive table-scroll small-first-col table-cell-styles" style="background: transparent;width:93%;margin:15px !important;"
      >
        <thead style="color: #eee">
          <tr style="height:40px;">
            <th scope="col" class="text-left" style="width:40%;">
              {{$t('Path')}}
            </th>
            <th scope="col" class="text-center" style="width:30%;">
              {{$t('Permission')}}
            </th>
            <th scope="col" class="text-center" style="width:20%;">
              {{$t('Recursive folder permission')}}
            </th>
            <th scope="col" class="text-center" style="width:10%;"></th>
          </tr>
        </thead>
        <tbody class="body-half-screen">
          <tr v-if="addNewRow" :key="newRowDetails.path">
            <td class="text-left col-md-6" style="width:40%;max-width:40%;" >
              <folder-multiselect :enableFolderBrowser="true" ref="newPath" @folderSelectionChanged="handlePathSelection" :enableMultiSelect="false" :setDefaultFocus="true" :binTypesFilter="['asset','deployment']"></folder-multiselect>
            </td>
            <td class="text-center col-md-3" style="width:30%;max-width:30%;">
              <Multiselect
              :value="newRowPerm.label"
              :options="permissionTypes"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              :label="label"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              :ref="newRowDetails.path"
              @select="editNewRowPermission($event)"
              @open="decideOpenDirection($event,newRowDetails)"
              :appendToBody="true"
              :openDirection="dropdownOpenDirection"
              :track-by="type">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
              </div>
              <span slot="noResult">No results.</span>
              </Multiselect>
            </td>
            <td class="text-center col-md-2" style="width:20%;max-width:20%;">
              <div
              class="custom-control custom-switch category-div" style="display: flex;justify-content: center;"
              >
              <input
                v-model="newRowDetails.apply_recursively"
                :id="newRowDetails._id"
                type="checkbox"
                class="custom-control-input"
              />
              <label
                class="custom-control-label category-label"
                :for="newRowDetails._id"
                >
                <div class="category-head" v-if="newRowDetails.apply_recursively">{{$t('Enabled')}}</div>
                <div class="category-head" v-else>{{$t('Disabled')}}</div>
              </label>
            </div>
            </td>
            <td class="col-md-1" style="width:10%;max-width:10%;">
              <svg
                v-on:click="deleteNewRowPermission()"
                width="2em"
                height="1.5em"
                viewBox="0 0 16 16"
                class="bi bi-trash delete-btn"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                />
                <path
                  fill-rule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                />
              </svg>
            </td>
          </tr>
          <tr v-for="key in binPermissions" :key="key.bin_id">
            <td class="text-left col-md-6">
              <span v-if="Object.keys(key).includes('name_path')" class="display-name-path">{{ key.name_path }}</span>
              <span v-else class="display-name-path">{{ getPathNameOfFolder(key.path)}}</span>
            </td>
            <td class="text-center col-md-3">
              <Multiselect
              :value="mapPermissionTypwWithLabel[key.access_right]"
              :options="permissionTypes"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="editTheUserPermission($event,key)"
              :label="label"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              :ref="key.path"
              @open="decideOpenDirection($event,key)"
              :appendToBody="true"
              :openDirection="dropdownOpenDirection"
              :track-by="type">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
              </div>
              <span slot="noResult">No results.</span>
              </Multiselect>
            </td>
            <td class="text-center col-md-2">
              <div
              class="custom-control custom-switch category-div"
              >
              <input
                v-model="key.apply_recursively"
                @change="updateRecursivePermission(key, $event)"
                :id="key._id"
                type="checkbox"
                class="custom-control-input"
              />
              <label
                class="custom-control-label category-label"
                :for="key._id"
                >
                <div class="category-head" v-if="key.apply_recursively">{{$t('Enabled')}}</div>
                <div class="category-head" v-else>{{$t('Disabled')}}</div>
              </label>
            </div>
            </td>
            <td class="col-md-1">
              <svg
                v-on:click="deleteBinPermission(key.path)"
                width="2em"
                height="1.5em"
                viewBox="0 0 16 16"
                class="bi bi-trash delete-btn"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                />
                <path
                  fill-rule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                />
              </svg>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="position: sticky;  inset-inline-end :22px;top: -4%;z-index: 99;">
        <svg
          width="2em"
          height="2em"
          viewBox="0 0 16 16"
          class="bi bi-plus-square mt-4"
          v-on:click="enableNewRow()"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          />
          <path
            fill-rule="evenodd"
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>



<script>
import FolderAutoComplete from "../bins/binsFoldersMultiDropdown.vue";
import {mapMutations,mapActions,mapGetters} from "vuex";
import Utils from "../../components.utils.js";
import Multiselect from 'vue-multiselect';
import {NotifierConstants} from "../../components.constants.js";

export default {
  props: ["selectedUserID","newUser","selectedUserInfo"],
  data() {
    return {
      newRowDetails:{
        access_right:"full-control",
        apply_recursively:false,
        name_path:"",
        path:"",
        _id:"new"
      },
      newRowPerm:{label:"FULL CONTROL",type:"full-control"},
      addNewRow:false,
      binPermissions: [],
      showDropdown: false,
      permissionTypes:[
        {label:"FULL CONTROL",type:"full-control"},
        {label:"READ MODIFY",type:"read-modify"},
        {label:"READ WRITE",type:"read-write"},
        {label:"READ ONLY",type:"read"},
        {label:"BROWSE", type:"browse"},
        {label:"NO ACCESS",type:"no-access"},
      ],
      mapPermissionTypwWithLabel:{
        "read":"READ ONLY",
        "read-write":"READ WRITE",
        "full-control":"FULL CONTROL",
        "no-access":"NO ACCESS",
        "browse":"BROWSE",
        "read-modify":"READ MODIFY"
      },
      displayIdNameMapper:{},
      dropdownOpenDirection:"below",
    };
  },
  methods: {
    enableNewRow(){
      if(this.addNewRow){
        alert("New row is already added.")
      }
      this.addNewRow = true
      this.$refs.newPath.focus()
    },
    resetNewRow(){
      this.addNewRow = false;
      this.newRowDetails = {
        access_right:"full-control",
        apply_recursively:false,
        name_path:"",
        path:""
      }
    },
    deleteNewRowPermission(){
      if(this.addNewRow){
        this.resetNewRow()
      }
    },
    getUserBinPermissions(){
      return this.binPermissions;
    },
    handlePathSelection(folderIdPath){
      let browsedFolders = [folderIdPath]
      if(Array.isArray(folderIdPath)){
        browsedFolders = folderIdPath
      }
      let pathInfoList = []
      for(let eachFolder of browsedFolders){
        let parentIdPath = eachFolder.parent_id_path + "/"+ eachFolder.id;
        pathInfoList.push({"path":parentIdPath,"access_right":this.newRowPerm['type'],"apply_recursively":this.newRowDetails.apply_recursively})
        this.displayIdNameMapper[eachFolder.id] = eachFolder.path
      }
      if(pathInfoList.length){
        this.updateUserBinPermissions("add", pathInfoList)
      }
    },
    getPathNameOfFolder(folderIdPath){
      console.log("folderIdPath")
      let pathList = folderIdPath.split("/");
      let folderId = pathList[pathList.length - 1]
      return this.displayIdNameMapper[folderId];
    },
    editTheUserPermission(e,key){
      this.updateUserBinPermissions('permission',[key],e)
    },
    updateUserBinPermissions(type,pathList,event){
      let userBinPermission = this.binPermissions;
      if(type == "add"){
        for(let path of pathList){
          let removeDuplicateBin = this.binPermissions.filter((val)=>val.path==path.path);
          if(removeDuplicateBin.length != 0){
              this.$toast.error(`Selected path "${path}" is already added. `);
              return;
          }else{
            userBinPermission.unshift(path);
          }
        }
      }else{
        if(!["rec-permission"].includes(type)){
          for (let binPermission of userBinPermission) {
              if(binPermission.path == pathList[0].path){
                binPermission.access_right = event.type;
              }
          }
        }
      }
      if(this.newUser){
        this.binPermissions = userBinPermission
        this.resetNewRow()
        return
      }
      let payload = {};
      payload.access_control = {bins:userBinPermission}
      payload.params = { user_id: this.selectedUserID };
      this.updateExistingUser(payload).then((data) => {
        this.resetNewRow()
        if (Utils.isAcceptedStatusCode(data.statusCode)) {
          if (data.message.includes("Failed")) {
            this.$toast.warning(data.message);
          } else {
            this.binPermissions = userBinPermission;
            if(this.getLoggedInUserId() != this.selectedUserID){
              this.$toast.success(data.message);
            }
          }
        } else {
          this.$toast.error(data.message);
        }
        this.refreshBinPermissionTable();
      });
    },
    updateRecursivePermission(key, e){
      this.updateUserBinPermissions('rec-permission',[key],e)
    },
     deleteBinPermission(path){
      if (confirm(`Are you sure you want to delete the selected bin permission ?`)) {
        let payload = {};
        payload.access_control = {bins:this.binPermissions.filter((val)=>val.path!=path)}
        payload.params = { user_id: this.selectedUserID };
        if(this.newUser){
          this.binPermissions = payload.access_control.bins;
          return
        }
        this.updateExistingUser(payload).then((data)=>{
        if (data.statusCode==200){
            this.refreshBinPermissionTable()
            if(this.getLoggedInUserId() != this.selectedUserID){
              this.$toast.success(data.message);
            }
        }else{
            this.$toast.error(data.message);
        }
        this.refreshBinPermissionTable();
    });
      }
    },
    refreshBinPermissionTable(){
      if(typeof(this.selectedUserID) != "undefined"){
          if(this.selectedUserInfo){
            this.binPermissions = this.selectedUserInfo.access_control.bins;
          }
      }
    },
    handleUsersNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let user_info = notification.message
        if (user_info._id == this.selectedUserID){
          this.binPermissions = user_info.access_control.bins.slice()   
        }
      }
    },
    handleBinDeletionNotification(notification){
    notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
    if(notification.message){
        let bin_info = notification.message;
          if(this.checkBinIdExists(this.binPermissions,bin_info.bin_id)){
            this.binPermissions = this.binPermissions.filter(e => e.bin_id != bin_info.bin_id);
          }
        }
    },
    checkBinIdExists(arr, binId) {
      const found = arr.some(el => el.bin_id === binId);
      return found;
    },
    editNewRowPermission(e){
      this.newRowPerm = e
      this.newRowDetails.access_right = e.type
    },
    decideOpenDirection(e,key){
      this.$nextTick(()=>{
        let divRef = this.$refs[key.path][0].$el.getBoundingClientRect();
        if(divRef.y > 410){
          this.dropdownOpenDirection = "above";
        }else{
          this.dropdownOpenDirection = "below";
        }
      })
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[ NotifierConstants.userModifiedNotification],
            callback:this.handleUsersNotification,
            parent:"BinsPermissions"})
      this.addWSEventListener({
            eventname:[ NotifierConstants.binRemovedNotification],
            callback:this.handleBinDeletionNotification,
            parent:"BinsPermissions"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[ NotifierConstants.userModifiedNotification],
            callback:this.handleUsersNotification,
            parent:"BinsPermissions"})
      this.removeWSEventListener({
            eventname:[ NotifierConstants.binRemovedNotification],
            callback:this.handleBinDeletionNotification,
            parent:"BinsPermissions"})
    },
    ...mapGetters("users", ["getLoggedInUserId"]),
    ...mapActions("users",["getUserInfoFromServer","updateExistingUser","checkUserLoginStatus"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"])
  },
  components: {
    "folder-multiselect":FolderAutoComplete,
    "Multiselect":Multiselect
  },
  created(){
    this.registerforWebsocketNotifications() 
        if(!this.newUser){
          this.refreshBinPermissionTable();
        }
    },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  }
};
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;

.showmodal {
  display: block;
}

.table-scroll {
    /*width:100%; */
    /* Decoration */
    border-spacing: 0;
    margin: 0px 15px;
    border: $secondary-border-color !important;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            border: $secondary-border-color !important;
            th {
            position: sticky;
            top: -1px;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr {
            height: 60px;
            }
            tr:hover{
                background: $bg-color-on-hover !important;
            }
        }
    }

    .table {
        th {
            border-top: none !important;
            padding:0 10px !important;
        }
        td {
            border-top: none !important;
            padding:0 1rem!important;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:0 10px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }


svg {
  color: #666666;
}

svg:hover {
  color: $text-color;
}

.delete-btn {
  visibility: hidden;
}
.body-half-screen tr:hover .delete-btn {
  visibility: visible;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.height-set-for-component {
  height: calc(100vh - 130px);
  overflow: auto;
}

::v-deep{
  .multiselect{
        width:87% !important;
  }
  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background;
        border: $border-color;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:70%;
      margin: 0;
      min-height: 38px;
      height: 38px;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
            // border: 1px solid #292828 !important;
            border: $border-color !important;
            display: block;
            background: $secondary-background-color;
            width: 100%;
            max-height: 245px !important;
            overflow: auto;
            border: $border-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
            position: absolute;
        }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color!important;
    }
    .multiselect__tags {
        background: transparent !important;
    }
    .multiselect__content-wrapper::-webkit-scrollbar {
     width: 8px;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-track {
      background: #22272b !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }
}

.custom-control-input{
  z-index:999;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.category-div {
    margin-inline-start: 6%;
    margin: 25px 14%;
    width: 86%;
}

.category-label {
  padding-top: 2px;
  font-weight: 600;
  display: block !important;
}
.category-head {
    float: inline-start;
    text-align: initial;
    width: 100%;
}
.display-name-path {
  word-break: break-all;
  width: 100%;
  display: inline-block;
}
</style>